export default class DateValidator {
    public static validateDateStrings(dates: string[]): boolean {
        return dates.every((date) => this.validateDateString(date));
    }

    public static validateDateString(date: string): boolean {
        const parsedDate = Date.parse(date);
        return !isNaN(parsedDate);
    }
}
